class CaseHabitHero extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('[data-slide]')];
    this.dots = [...this.querySelectorAll('[data-dot]')];
    this.index = 0;
    this.delay = Number(this.dataset.delay || 5500);
    this.autoplay = this.dataset.autoplay === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.go(index, true)));
    this.addEventListener('pointerdown', event => this.startX = event.clientX);
    this.addEventListener('pointerup', event => { if (Math.abs(event.clientX - this.startX) > 48) this.go(event.clientX < this.startX ? this.index + 1 : this.index - 1, true); });
    this.addEventListener('mouseenter', () => this.pause()); this.addEventListener('mouseleave', () => this.play());
    this.play();
  }
  go(index, interacted = false) { this.index = (index + this.slides.length) % this.slides.length; this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === this.index)); this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === this.index)); if (interacted) { this.pause(); this.play(); } }
  play() { if (this.autoplay && this.slides.length > 1) { this.pause(); this.timer = setInterval(() => this.go(this.index + 1), this.delay); } }
  pause() { clearInterval(this.timer); }
}
customElements.define('case-habit-hero', CaseHabitHero);
